import React from 'react'

export function useInterval(callback: () => void, delay: number | null) {
    const ref = React.useRef<(() => void) | null>(null)

    React.useEffect(() => {
        if (ref) {
            ref.current = callback
        }
    }, [callback])

    React.useEffect(() => {
        function tick() {
            if (ref?.current) {
                ref.current()
            }
        }

        if (delay) {
            const id = setInterval(tick, delay)
            return () => clearInterval(id)
        }
        return undefined
    }, [delay])
}
